const setTypeDay = (price, trip) => {

  if (!trip) return "none";

  if (price < parseFloat(trip.price_from)) return "low";
  else if (price >= parseFloat(trip.price_from) && price <= parseFloat(trip.price_to))
    return "medium";
  else return "high";
}

export default setTypeDay;

